import { createStore } from '@cobuildlab/react-simple-state';
import { DialogAlertEnum } from './alert-types';
import { ReactNode } from 'react';

export const dialogAlertStore = createStore<{
  isOpen: boolean;
  message: string | ReactNode | undefined;
  type: DialogAlertEnum | undefined;
  extraAction?: () => void;
}>({
  initialValue: {
    isOpen: false,
    message: undefined,
    type: undefined,
    extraAction: undefined,
  },
});
